import { render, staticRenderFns } from "./bdd-violations-register.vue?vue&type=template&id=550fceef"
import script from "./bdd-violations-register.vue?vue&type=script&lang=js"
export * from "./bdd-violations-register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports